export default __webpack_public_path__ + "static/media/covid-tracker-banner.9e5d4fc7.png";